"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMasterUserSubmittedClaimSchema = exports.masterUserSubmittedClaimSchema = void 0;
var constants_1 = require("@hobt/constants");
var schema_validator_1 = require("@hobt/schema-validator");
var common_1 = require("../common");
var borrower_charges_1 = require("./borrower-charges");
var borrower_details_1 = require("./borrower-details");
var constants_2 = require("../constants");
var default_management_1 = require("./default-management");
var detail_1 = require("./detail");
var indicator_1 = require("./indicator");
var lender_1 = require("./lender");
var listing_1 = require("./listing");
var net_operating_income_rental_income_1 = require("./net-operating-income-rental-income");
var partial_payment_1 = require("./partial-payment");
var property_1 = require("./property");
var validation_result_1 = require("./validation-result");
exports.masterUserSubmittedClaimSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [
        'approvedLenderFinancialInstitutionCode',
        'approvedLenderReferenceNumber',
        'approvedLenderTransitNumber',
        'claimTypeIndicator',
        'cmhcLoanAccountNumber',
        'exceptionToListingFlag',
        'partialPaymentReceivedFlag',
        'rentalIncomeReceivedFlag',
        'borrowers',
        'defaultManagement',
        'detail',
        'lender',
        'listings',
        'property',
    ],
    properties: {
        approvedLenderFinancialInstitutionCode: {
            type: 'string',
            minLength: 3,
            maxLength: 3,
            errorMessage: 'Should be a string with 3 characters',
        },
        approvedLenderReferenceNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 20,
            errorMessage: 'Should be a string with a maximum of 20 characters',
        },
        approvedLenderTransitNumber: {
            type: 'string',
            minLength: 5,
            maxLength: 5,
            errorMessage: 'Should be a string with 5 characters',
        },
        attachments: {
            type: ['array', 'null'],
            minItems: 0,
            maxItems: 20,
            items: common_1.attachmentSchema,
            errorMessage: 'Should be an array of Attachments with maximum 20 attachments',
        },
        claimBusinessID: {
            type: 'string',
            minLength: 0,
            maxLength: 30,
            errorMessage: 'Should be a string with a maximum of 30 characters',
        },
        claimID: {
            type: ['string', 'null'],
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000 or null',
        },
        claimTypeIndicator: {
            type: 'number',
            enum: Object.values(constants_2.ClaimTypeIndicator),
            errorMessage: 'Should equate to a valid ClaimTypeIndicator Enum value',
        },
        cmhcLoanAccountNumber: {
            type: 'number',
            minimum: 10000000,
            maximum: 99999999,
            errorMessage: 'Should be a numeric value with 8 digits',
        },
        exceptionToListingFlag: {
            type: ['boolean', 'string'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'should be true or false',
        },
        partialPaymentReceivedFlag: {
            type: ['boolean', 'string'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'should be true or false',
        },
        rentalIncomeReceivedFlag: {
            type: ['boolean', 'string'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'should be true or false',
        },
        sequenceNumber: {
            type: 'number',
            minimum: 0,
            maximum: 2147483647,
            errorMessage: 'Should be an integer between 0 and 2147483647',
        },
        validationResult: validation_result_1.validationResultSchema,
        indicator: indicator_1.indicatorSchema,
        lender: lender_1.lenderSchema,
        borrowers: {
            type: 'array',
            items: borrower_details_1.borrowerDetailsSchema,
            minItems: 1,
            maxItems: 10,
        },
        property: property_1.propertySchema,
        defaultManagement: default_management_1.defaultManagementSchema,
        detail: detail_1.detailSchema,
        listings: {
            type: 'array',
            items: listing_1.listingSchema,
            minItems: 1,
            isAfterFirstListingDate: ['appraisalDate', 'comparativeMarketAnalysisDate', 'date'],
            isLessThanFirstListingAmount: ['revisedPriceAmount'],
        },
        borrowerCharges: {
            type: ['array', 'null'],
            items: borrower_charges_1.borrowerChargesSchema,
        },
        partialPayments: {
            type: ['array', 'null'],
            items: partial_payment_1.partialPaymentsSchema,
        },
        netOperatingIncomesRentalIncomes: {
            type: ['array', 'null'],
            items: net_operating_income_rental_income_1.netOperatingIncomeRentalIncomeSchema,
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: constants_1.dateTimePattern,
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000',
        },
        recordCreatedUserID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: constants_1.dateTimePattern,
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000',
        },
        recordUpdatedUserID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
    },
};
exports.getMasterUserSubmittedClaimSchema = function () {
    return new schema_validator_1.SchemaValidator(exports.masterUserSubmittedClaimSchema, true, false, true, true);
};
